// extracted by mini-css-extract-plugin
export default {"accordion-item":"AccordionItem_accordion-item__frG3X","accordion-header":"AccordionItem_accordion-header__IBKgl","accordion-body":"AccordionItem_accordion-body__CiDWC"};